import { Box, BoxProps, useTheme } from '@chakra-ui/react';
import { Overlay } from 'components';
import { FC } from 'react';
import { mq } from 'styles/breakpoints';

interface BoxMainProps {
  height?: string;
  ready?: boolean;
  overlayHeight?: string;
  overlayType?: OverlayType;
  noPaddingOnMobile?: boolean;
  noBgOnMobile?: boolean;
}

const BoxMain: FC<BoxMainProps & BoxProps> = ({
  children,
  height,
  ready = true,
  overlayHeight,
  overlayType,
  noPaddingOnMobile,
  noBgOnMobile,
  ...rest
}) => {
  const { colors } = useTheme();

  return (
    <Box
      h={height ?? '100%'}
      sx={{
        background: noBgOnMobile ? 'transparent' : colors.white,
        [mq.md]: {
          background: colors.white,
          p: '20px 24px',
        },
      }}
      layerStyle={noPaddingOnMobile ? 'whiteBoxContentWithoutMobilePadding' : 'whiteBoxContent'}
      {...rest}
    >
      {ready ? children : <Overlay overlayHeight={overlayHeight} type={overlayType} />}
    </Box>
  );
};

export default BoxMain;
